/**
 * <ColorPicker />
 *
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import Select from 'react-select';
import { CirclePicker } from 'react-color'

export function colorpicker(props) {
  const {
    value,
    schema,
    onChange,
    options,
    placeholder,
  } = props;

  const {
    name,
  } = schema;

  return (
    <ColorPicker 
      name={name}
      value={value}
      onChange={onChange}
      {...options}
    />
  );
}

class ColorPicker extends React.Component {
  static propTypes = {

  }

  constructor(props) {
    super(props);
    this.onChangeComplete = this.onChangeComplete.bind(this);
  }

  onChangeComplete(color, evt) {
    this.props.onChange(color.hex);
  }

  render() {
    const {
      name,
      value,
      onChange,
      width,
    } = this.props

    return (
      <div className={classnames('color-picker-wrapper')} >
        <CirclePicker color={value} onChangeComplete={this.onChangeComplete} width={width} />
      </div>
    ) 
  }
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/ColorPicker.js